import { useEffect, useState } from 'react';
import { getAuthCooldownRemaining, subscribeAuthRateLimit } from '@/api/authRateLimit';
/** Оставшиеся секунды клиентского cooldown для auth-ручки (после 429). */
export function useAuthCooldown(path) {
    const [seconds, setSeconds] = useState(() => getAuthCooldownRemaining(path));
    useEffect(() => {
        const sync = () => setSeconds(getAuthCooldownRemaining(path));
        sync();
        const unsubscribe = subscribeAuthRateLimit(sync);
        const id = window.setInterval(sync, 1000);
        return () => {
            unsubscribe();
            window.clearInterval(id);
        };
    }, [path]);
    return seconds;
}
